module.exports = __webpack_public_path__ + "img/default_en.725802e.jpg";